module.exports = __webpack_public_path__ + "static/media/img-portofolio-2.c0eb01a0.png";